/* eslint-disable */
import {
  Paper,
  Grid,
  Typography,
  Button,
  TextField,
  CircularProgress,
  InputAdornment,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Cookies from 'js-cookie';
import moment from 'moment';
import Visibility from '@material-ui/icons/Visibility';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { FastField, Formik, Form, Field } from 'formik';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { object, string } from 'yup';
import useAuth from '../../../hooks/useAuth';
import {} from '../../../utils';
import useUtilities from '../../../hooks/useUtilities';
import useClassInstance from '../../../hooks/useClassInstance';
import ajax from '../../../utils/ajaxHelper';
import { isValidMongoId, showErrIfTouched, isWidgetPage } from '../../../utils';

import useStyles from './CheckInResponse.style';
import ABIInvalidPackModal from '../../Main/Calendar/ABIInvalidPackModal';
import { ABI_BASE_URL } from '../../../constants/globalConstants';

const BookEvent = () => {
  const { eventId, classInstanceId } = useParams();
  const { login, requestCompanyId, fetchCompanyId } = useAuth();
  const [classInstance, setClassInstance] = useState(null);
  const { isLoggedIn } = useUtilities();

  const dispatch = useDispatch();

  const { registerClass, validateClassRegistration } = useClassInstance();
  const classes = useStyles();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.parent.postMessage('scrollTop', '*');
  }, []);
  useEffect(() => {
    (async () => {
      if (eventId && isValidMongoId(eventId)) {
        const companyId = await fetchCompanyId();
        const res = await ajax.post(
          'get-event-details',
          {
            companyId,
            eventId,
          },
          {
            networkParams: { showLoader: false },
          },
        );
        sessionStorage.setItem('isABI', true);

        if (res?.alreadyRegistered) {
          navigate(`../../../event/cancel-event/${eventId}`);
        } else if (res?.isClassFull) {
          navigate(`../../../event/fully-booked/${eventId}`);
        } else if (window.location.href.includes('/payment/')) {
          await registerClass(
            eventId,
            null,
            moment(res?.data?.date).startOf('week').toDate(),
            true,
            () => {},
          );
        } else {
          setClassInstance(res?.data?._id ? res?.data : null);
          //validate and book a session/class
          setTimeout(() => {
            validateClassRegistration(
              eventId,
              null,
              moment(res?.data?.date).startOf('week').toDate(),
              true,
              () => {},
              true,
            );
          }, 1000);
        }
      }
    })();
  }, [eventId]);
  return (
    <If condition={classInstance?.classId?.className}>
      <If condition={isLoggedIn()}>
        <Grid container justify="flex-end">
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              className={classes.logoutBtn}
              onClick={async () => {
                try {
                  await ajax.post('logout');
                } catch (error) {
                  console.log(error);
                } finally {
                  Cookies.remove('token');
                  Cookies.remove('hosttype');
                  Cookies.remove('user');
                  dispatch({ type: 'USER', payload: {} });

                  top.location.replace(`${ABI_BASE_URL}/events/${eventId}`);
                }
              }}
            >
              LOG OUT
            </Button>
          </Grid>
        </Grid>
      </If>
      <Grid container justify="center" alignItems="center" className={classes.root}>
        <Paper className={classes.paper}>
          <div className={classes.confirmationcontentbox}>
            <Grid container spacing={6} justify="center">
              <Grid item xs={12}>
                {}
              </Grid>
              <Grid item xs={12}>
                {}
              </Grid>
            </Grid>
            <Typography className={classes.confirmationheading}>
              {`Booking for ${classInstance?.classId?.className}`}
            </Typography>
            <Typography className={classes.confirmationtext}>
              Processing your request, please wait...
            </Typography>

            <Grid container spacing={6} justify="center">
              <Grid item xs={12}>
                {}
              </Grid>
              <Grid item xs={12}>
                {}
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Grid>

      <ABIInvalidPackModal />
    </If>
  );
};

BookEvent.propTypes = {};

export default BookEvent;
